import { ArticleDTO, ArticleModel } from "./Article";

type MediaType = "film" | "serie";
export interface MediaDTO {
  _id: string;
  mediaId: number;
  title: string;
  originalTitle?: string;
  slug: string;
  type: MediaType;
  isFeatured?: boolean;
  premierDate: string;
  poster: string;
  year?: number;
  directors?: string[];
  genres?: string[];
  countries?: string[];
  trailerUrl?: string;
  playerUrl?: string;
  assetsUrl?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  body?: any[];
  articles?: ArticleDTO[];
}

export class MediaModel {
  readonly _id: string;
  readonly mediaId: number;
  readonly title: string;
  readonly originalTitle?: string;
  readonly slug: string;
  readonly type: MediaType;
  readonly isFeatured?: boolean;
  readonly premierDate?: Date;
  readonly poster: string;
  readonly year?: number;
  readonly directors?: string[];
  readonly genres?: string[];
  readonly countries?: string[];
  readonly trailerUrl?: string;
  readonly playerUrl?: string;
  readonly assetsUrl?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  readonly body?: any[];
  readonly articles?: ArticleModel[];

  constructor(mediaDTO: MediaDTO) {
    this._id = mediaDTO._id;
    this.mediaId = mediaDTO.mediaId;
    this.title = mediaDTO.title;
    this.originalTitle = mediaDTO.originalTitle;
    this.slug = mediaDTO.slug;
    this.type = mediaDTO.type;
    this.isFeatured = mediaDTO.isFeatured;
    this.premierDate = new Date(mediaDTO.premierDate);
    this.poster = mediaDTO.poster;
    this.year = mediaDTO.year;
    this.directors = mediaDTO.directors;
    this.genres = mediaDTO.genres;
    this.countries = mediaDTO.countries;
    this.trailerUrl = mediaDTO.trailerUrl;
    this.playerUrl = mediaDTO.playerUrl;
    this.assetsUrl = mediaDTO.assetsUrl;
    this.body = mediaDTO.body;
    if (mediaDTO.articles?.length)
      this.articles = mediaDTO.articles.map(
        (article) => new ArticleModel(article)
      );
  }

  toJSON() {
    return { ...this };
  }
}
